import React, { useState } from 'react'
import * as styles from './Grid.module.scss'
import { Link } from 'gatsby'
import kebabCase from 'lodash/kebabCase'
import { SpotlightCourse } from '../academy/Grid'

const Grid = ({ data, spotlight }) => {
  return (
    <>
      <div className={styles.section}>
        <div className={styles.content}>
          <div>
            <div className={styles.grid}>
              {data.slice(0, 5).map((m, index) => {
                if (index === 4) {
                  return (
                    spotlight && (
                      <div key="spotlight" className={styles.doubleColumns}>
                        <SpotlightCourse spotlight={spotlight} />
                      </div>
                    )
                  )
                }

                if (index === 5) return null

                return (
                  <GridItem
                    key={m.id || m.title}
                    title={m.title}
                    tag={m.topic}
                    description={m.description}
                    image={m.featuredImage?.asset?.url}
                    link={`/guides/${kebabCase(m.title)}/`}
                  />
                )
              })}
              {data.slice(4).map((m) => (
                <GridItem
                  key={m.id || m.title}
                  title={m.title}
                  tag={m.topic}
                  description={m.description}
                  image={m.featuredImage?.asset?.url}
                  link={`/guides/${kebabCase(m.title)}/`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const GridItem = ({ title, link, description, tag }) => {
  const [hover, setHover] = useState(false)
  return (
    <Link to={link}>
      <div
        className={styles.postCard}
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
      >
        <div className={`${styles.cardContent} ${hover && styles.hovered}`}>
          <span className={styles.tag}>{tag}</span>
          <h3>{title}</h3>
          <p>{description}</p>
        </div>
      </div>
    </Link>
  )
}

export default Grid
